var React = require('react');

function DribbbleInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0Zm9.9 11.4c-2.6-.4-4.9-.4-7.1-.1-.2-.6-.5-1.1-.8-1.7 2.3-1 4.2-2.4 5.5-4.1 1.4 1.7 2.3 3.7 2.4 5.9ZM18 4.2c-1.2 1.6-2.9 2.8-5 3.7-1-1.9-2.1-3.7-3.4-5.5.8-.2 1.6-.3 2.4-.3 2.3 0 4.4.8 6 2.1Zm-10.5-1C8.8 4.9 10 6.7 11 8.6c-2.4.7-5.3 1-8.6 1.1.7-2.9 2.6-5.2 5.1-6.5ZM2.1 12v-.3c3.8 0 7.2-.4 9.9-1.3.2.5.5 1 .7 1.4-3.4 1.1-6.2 3.2-8.3 6.5C3 16.6 2.1 14.4 2.1 12Zm3.8 7.8c2-3.1 4.5-5.1 7.6-6 .9 2.4 1.6 4.9 2 7.5-3.3 1.2-6.9.6-9.6-1.5Zm11.6.4c-.4-2.4-1.1-4.7-1.9-6.9 1.9-.3 3.9-.2 6.2.2-.5 2.8-2 5.2-4.3 6.7Z"}));
}

DribbbleInline.defaultProps = {"fill":"none","viewBox":"0 0 24 24"};

module.exports = DribbbleInline;

DribbbleInline.default = DribbbleInline;
